export default "__VITE_ASSET__C2u2fz7n__"